import { AnyAction } from 'redux';
import { ReduxAction, SigningMethod } from '../../enums/const-enums';
import { MethodState } from '../reducers/method-reducer';

export const initMethods = (methods: MethodState): AnyAction => {
  return {
    type: ReduxAction.INIT_METHODS,
    payload: methods,
  };
};

export const setActiveMethod = (activeSignMethod: SigningMethod): AnyAction => {
  return {
    type: ReduxAction.SET_ACTIVE_METHOD,
    payload: { activeSignMethod },
  };
};

export const setActiveMethodStatus = (
  activeSignMethodStatus: string,
): AnyAction => {
  return {
    type: ReduxAction.SET_ACTIVE_METHOD_STATUS,
    payload: { activeSignMethodStatus },
  };
};

export const setAllowedMethods = (
  allowedSignMethods: Array<SigningMethod>,
): AnyAction => {
  return {
    type: ReduxAction.SET_ALLOWED_METHODS,
    payload: { allowedSignMethods },
  };
};

export const setPreferredMethod = (
  preferredSignMethod: SigningMethod,
): AnyAction => {
  return {
    type: ReduxAction.SET_PREFERRED_METHOD,
    payload: { preferredSignMethod },
  };
};
